import { useArtworkApprovalContextStore } from "../../context/approvals/ArtworkApprovalsContext";
import {
  formatCollectionOptions,
  getCollections,
} from "../../helpers/collections.helper";
import OptionFormatter from "../../../../components/OptionFormatter";
import AsyncSelect from "react-select/async";
import Select from "react-select";
import {
  formatRequestorMarketIntoOption,
  getRequestorMarkets,
} from "../../../../helpers/requestor-market.helper";
import {
  formatLicensorIntoOption,
  getLicensors,
} from "../../../../helpers/licensor.helper";
import { useLicensorContext } from "../../../../context/LicensorContext";
import useRequestorMarket from "../../../../hooks/useRequestorMarket";
import { ArtworkApprovalActions } from "../../state/approvals";
import { ArtworkApprovalRequestTypes } from "../../state/approvals/data.type";
import { Predicates } from "../../../../libraries/predicates/predicates";
import {
  formatLicensedPropertyIntoOption,
  getLicensedPropertys,
} from "../../../../helpers/licensed-property.helper";
import useLicensedProperty, {
  fetchLicensedProperty,
} from "../../../../hooks/useLicensedProperty";
import useAxios from "../../../../utils/useAxios";
import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { isStateEqualToInitialState } from "../../state/approvals/Reducer";
import {
  DebounceContext,
  DebounceContextType,
} from "../../../../context/DebounceContext";
import { useGetCollectionsHook } from "../../hooks/useGetCollectionsHook";
import { ArtworkCollectionAsyncSelect } from "../artworkCollectionAsyncSelect";
import { usePageableTable } from "../../../../context/PageableTableContext";


export const CollectionsFilterForm = () => {
  const { state, dispatch } = useArtworkApprovalContextStore();
  const {
    dispatch: dispatchPageTable,
    state: { offset },
  } = usePageableTable();

  const { data: licensors, isLoading: isLicensorsLoading } =
    useLicensorContext();
  const { data: requestorMarket, isLoading: isRequestorMarketsLoading } =
    useRequestorMarket();
  const axios = useAxios();
  const { searchDebounce } = useContext<DebounceContextType>(DebounceContext);

  const { data: licensedProperties, isLoading: isLicensedPropertiesLoading } =
    useLicensedProperty({
      licensorId: String(
        state?.collectionSearchFilters?.licensor?.id?.toString() ?? "",
      ),
    });

  const searchCollections = useMemo(() => {
    return { search: { status: "APPROVED" } };
  }, []);
  const {
    data: collections,
    isLoading: loadingCollections,
    getCollection,
  } = useGetCollectionsHook(searchCollections);

  const [hasFilterdApplied, setHasFilteredApplied] = useState(false);

  const licensedPropertiesOptions = async (search: string, callback: any) => {
    if (Predicates.isNullOrUndefined(search) || search.length < 3)
      return getLicensedPropertys(licensedProperties);
    const response = await fetchLicensedProperty({
      licensorId: String(
        String(state?.collectionSearchFilters?.licensor?.id?.toString() ?? ""),
      ),
      search,
      axios,
    });
    callback(getLicensedPropertys(response));
  };

  const handleClearFilters = () => {
    dispatch(
      ArtworkApprovalActions.setStateValue(
        ArtworkApprovalRequestTypes.SET_COLLECTION_SEARCH_FILTERS,
        {
          collection: null,
          printingTechnique: null,
          launch_date: "",
          licensed_property: null,
          licensor: null,
          limit: 0,
          offset: offset,
          requesting_market: null,
          search: "",
          year: "",
        },
      ),
    );
  };

  // const collectionsOptions = getCollections(collections?.results);

  useEffect(() => {
    setHasFilteredApplied(
      isStateEqualToInitialState(state, "collectionSearchFilters"),
    );
  }, [{ ...state.collectionSearchFilters }]);

  const handleSearch = async (callback: any) => {

    dispatch(
      ArtworkApprovalActions.setStateValue(
        ArtworkApprovalRequestTypes.SET_COLLECTION_SEARCH_IS_LOADING,
        true,
      ),
    )

    const filters = {
      search: {
        search: state.collectionSearchFilters.collection?.code,
        status: "APPROVED",
        name: state.collectionSearchFilters.collection?.name,
        limit: 50,
        offset: offset,
        licensor: state.collectionSearchFilters?.licensor?.id,
        requesting_market:
          state.collectionSearchFilters?.requesting_market?.id,
        licensed_property:
          state.collectionSearchFilters?.licensed_property?.id,
        launch_date: state.collectionSearchFilters?.launch_date,
        year: state.collectionSearchFilters?.year,
      },
    };

    const res = await getCollection({ ...filters } );

      dispatch(
        ArtworkApprovalActions.setStateValue(
          ArtworkApprovalRequestTypes.SET_COLLECTION_SEARCH_RESULTS,
          res,
        ),
      )

    dispatch(
      ArtworkApprovalActions.setStateValue(
        ArtworkApprovalRequestTypes.SET_COLLECTION_SEARCH_IS_LOADING,
        false,
      ),
    )
  };

  const handleUpdateFilters = (key: any, value: any) => {
    dispatch(
      ArtworkApprovalActions.setStateValue(
        ArtworkApprovalRequestTypes.SET_COLLECTION_SEARCH_FILTERS,
        {
          ...state.collectionSearchFilters,
          [key]: value,
        },
      ),
    );
  };

  useEffect(() =>{
      handleSearch(null)
  },[offset])

  return (
    <div className="w-100">
      <div className="row">
        <div className="col-lg-4 form-group">
          <ArtworkCollectionAsyncSelect
            onChanged={(e: any) => {
              handleUpdateFilters("collection", e);
            }}
            value={
              state?.collectionSearchFilters?.collection ?? undefined
            }
          />
        </div>

        <div className="col-lg-2 form-group">
          <label className="form-label">Licensor</label>
          <Select
            onChange={(e: any) => {
              dispatch(
                ArtworkApprovalActions.setStateValue(
                  ArtworkApprovalRequestTypes.SET_COLLECTION_SEARCH_FILTERS,
                  {
                    ...state.collectionSearchFilters,
                    licensor: e ? e.value : null,
                    licensed_property: null,
                  },
                ),
              );
            }}
            value={formatLicensorIntoOption(
              state?.collectionSearchFilters?.licensor,
            )}
            formatOptionLabel={OptionFormatter}
            options={getLicensors(licensors)}
            isClearable={true}
            classNamePrefix="react-select"
          />
        </div>

        <div className="col-lg-2 form-group">
          <label className="form-label">License</label>
          <AsyncSelect
            loadOptions={(input, callback) => {
              searchDebounce(
                licensedPropertiesOptions,
                input,
                getLicensedPropertys(licensedProperties),
                callback,
              );
            }}
            defaultOptions={getLicensedPropertys(licensedProperties)}
            onChange={(e: any) =>
              dispatch(
                ArtworkApprovalActions.setStateValue(
                  ArtworkApprovalRequestTypes.SET_COLLECTION_SEARCH_FILTERS,
                  {
                    ...state.collectionSearchFilters,
                    licensed_property: e ? e.value : null,
                  },
                ),
              )
            }
            formatOptionLabel={OptionFormatter}
            value={formatLicensedPropertyIntoOption(
              state?.collectionSearchFilters?.licensed_property,
            )}
            classNamePrefix="react-select"
            placeholder=""
            isClearable
            // isLoading={isLicensedPropertiesLoading}
            components={{
              IndicatorSeparator: () => null,
            }}
          />
        </div>

        <div className="col-lg-2 form-group">
          <label className="form-label">
            Requesting Market          </label>
          <Select
            options={getRequestorMarkets(requestorMarket)}
            onChange={(e: any) => {
              dispatch(
                ArtworkApprovalActions.setStateValue(
                  ArtworkApprovalRequestTypes.SET_COLLECTION_SEARCH_FILTERS,
                  {
                    ...state.collectionSearchFilters,
                    requesting_market: e
                      ? e.value
                      : { full_name: "", id: "", short_name: "" },
                  },
                ),
              );
            }}
            formatOptionLabel={OptionFormatter}
            value={formatRequestorMarketIntoOption(
              state?.collectionSearchFilters?.requesting_market,
            )}
            classNamePrefix="react-select"
            placeholder=""
            isClearable={true}
            isLoading={isRequestorMarketsLoading}
            components={{
              IndicatorSeparator: () => null,
            }}
          />
        </div>

        <div className="col-lg-2 form-group">
          <label className="form-label">Launch Date</label>
          <input
            onChange={(e: any) => {
              dispatch(
                ArtworkApprovalActions.setStateValue(
                  ArtworkApprovalRequestTypes.SET_COLLECTION_SEARCH_FILTERS,
                  {
                    ...state.collectionSearchFilters,
                    launch_date: e.target.value,
                  },
                ),
              );
            }}
            value={state?.collectionSearchFilters?.launch_date}
            type="date"
            className="form-control d-inline"
          />
        </div>
      </div>

      <div className="row p-0">
        <div className="d-flex justify-content-end gap-3 px-1 mt-2">
          <button
            className="btn btn-outline-primary"
            onClick={handleClearFilters}
            disabled={hasFilterdApplied}
          >
            Clear
          </button>
          <button
            className="btn btn-primary"
            onClick={handleSearch}
            // disabled={hasFilterdApplied}
          >
            Search
          </button>
        </div>
      </div>
    </div>
  );
};
